import React, { memo } from 'react'
import { APP_CONFIG } from '../../../common/constants'
import { SvgIcon } from '../../../../../components'

const PrintHeader = () => (
  <div className="appBrandingGroup">
    <SvgIcon src={APP_CONFIG.logoUrl} svgClasses="appLogo" alt="App Logo" />
    <div className="aboutAppHeading">
      <div className="aboutAppAcronym">
        <span className="aboutAppAcronym__label"></span>
        {APP_CONFIG.appCode}
      </div>
      <div className="aboutAppFullName">{APP_CONFIG.appName}</div>
    </div>
  </div>
)

export default memo(PrintHeader)
